import {createStyles} from '@mantine/core';
import classNames from 'classnames';
import React from 'react';

import {WHITE} from 'ui-library/Colors';

export interface SignupModalProps {
  children?: JSX.Element;
  tall?: boolean;
}

const useStyles = createStyles((_theme, {tall}: {tall: boolean}) => ({
  page: {
    paddingTop: '107px',
  },
  modal: {
    borderTop: '7px solid #2A5CF9',
    borderRadius: '0px 0px 4px 4px',
    boxShadow: '0px 2px 6px rgba(162, 185, 190, 0.7)',
    height: tall ? '520px' : '476px',
    width: '775px',
    backgroundColor: WHITE,
  },
}));

function SignupModal(props: SignupModalProps): JSX.Element {
  const {classes} = useStyles({tall: props.tall ?? false});
  return <div className={classes.modal}>{props.children != null && props.children}</div>;
}

export interface SignupScreenProps {
  children?: JSX.Element;
  tall?: boolean;
}

export default function SignupScreen(props: SignupScreenProps): JSX.Element {
  const {classes} = useStyles({tall: props.tall ?? false});
  return (
    <div className={classNames('container u-flex-grow u-justify-content-center', classes.page)}>
      <SignupModal tall={props.tall}>{props.children}</SignupModal>
    </div>
  );
}
